(() => {
  if (!window.ProtonHomepageFeedRuntime?.initialized) {
    const feedObservers = new WeakMap();

    const connectInstagramFeed = (root = document) => {
      const feed = root.querySelector?.('#insta-feed');
      const placeholder = root.querySelector?.('[data-proton-instagram-placeholder]');
      if (!feed || !placeholder || feed.dataset.protonFeedObserver === 'true') return;

      feed.dataset.protonFeedObserver = 'true';

      const syncPlaceholder = () => {
        const hasFeedContent = Boolean(feed.querySelector('img, video, [data-instafeed-thumbnail]'));
        placeholder.hidden = hasFeedContent;
      };

      syncPlaceholder();
      const observer = new MutationObserver(syncPlaceholder);
      observer.observe(feed, {
        childList: true,
        subtree: true,
        characterData: true,
      });
      feedObservers.set(feed, observer);
    };

    const disconnectInstagramFeed = (root) => {
      const feed = root.querySelector?.('#insta-feed');
      const observer = feed && feedObservers.get(feed);
      observer?.disconnect();
      if (feed) {
        feedObservers.delete(feed);
        delete feed.dataset.protonFeedObserver;
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', connectInstagramFeed, { once: true });
    } else {
      connectInstagramFeed();
    }
    document.addEventListener('shopify:section:load', (event) => connectInstagramFeed(event.target));
    document.addEventListener('shopify:section:reorder', (event) => connectInstagramFeed(event.target));
    document.addEventListener('shopify:section:unload', (event) => disconnectInstagramFeed(event.target));

    window.ProtonHomepageFeedRuntime = {
      initialized: true,
      connect: connectInstagramFeed,
      disconnect: disconnectInstagramFeed,
    };
  }

  if (customElements.get('proton-home-video')) return;

  class ProtonHomeVideo extends HTMLElement {
    connectedCallback() {
      if (this.motionQuery) return;

      this.video = this.querySelector('video');
      if (!this.video) return;

      this.selectBundledVideo();

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handleMotionPreference = () => {
        if (this.motionQuery.matches) {
          this.video.pause();
          this.video.autoplay = false;
          this.video.removeAttribute('autoplay');
          return;
        }

        this.video.autoplay = true;
        this.video.setAttribute('autoplay', '');
        const playback = this.video.play();
        playback?.catch(() => {});
      };

      this.motionQuery.addEventListener?.('change', this.handleMotionPreference);
      this.motionQuery.addListener?.(this.handleMotionPreference);
      this.handleMotionPreference();
    }

    selectBundledVideo() {
      const variants = ['branding', 'paddle'].filter((variant) => {
        const suffix = `${variant[0].toUpperCase()}${variant.slice(1)}`;
        return this.video.dataset[`homeVideo${suffix}`];
      });
      if (variants.length === 0) return;

      const forcedVariant = new URLSearchParams(window.location.search).get('hero');
      let selectedVariant = variants.includes(forcedVariant) ? forcedVariant : null;

      if (!selectedVariant) {
        try {
          selectedVariant = window.sessionStorage.getItem('protonHomeHeroVariant');
        } catch (_error) {
          selectedVariant = null;
        }
      }

      if (!variants.includes(selectedVariant)) {
        selectedVariant = variants[Math.floor(Math.random() * variants.length)];
        try {
          window.sessionStorage.setItem('protonHomeHeroVariant', selectedVariant);
        } catch (_error) {
          // Playback does not depend on storage access.
        }
      }

      const datasetSuffix = `${selectedVariant[0].toUpperCase()}${selectedVariant.slice(1)}`;
      this.video.poster = this.video.dataset[`homePoster${datasetSuffix}`];
      this.video.src = this.video.dataset[`homeVideo${datasetSuffix}`];
      this.video.dataset.homeVideoSelected = selectedVariant;
      this.video.load();
    }

    disconnectedCallback() {
      if (!this.motionQuery || !this.handleMotionPreference) return;

      this.motionQuery.removeEventListener?.('change', this.handleMotionPreference);
      this.motionQuery.removeListener?.(this.handleMotionPreference);
      this.motionQuery = null;
    }
  }

  customElements.define('proton-home-video', ProtonHomeVideo);
})();
